module.exports = __webpack_public_path__ + "media/images/icons/outlined/column-width-d7709c479ebb9ad60eb32eb7cf891098.svg";